import { ActivatedRouteSnapshot } from '@angular/router';

const getRouteParams = (route: ActivatedRouteSnapshot, params: any) => {
  const newParams = { ...params, ...route.params };
  if (!route.firstChild) return newParams;
  return getRouteParams(route.firstChild, newParams);
};

export const getAllRouteParams = (route: ActivatedRouteSnapshot) => {
  return getRouteParams(route.root, {});
};
